import { IState } from "./iState";

export const initialState: IState = {
    setting: undefined,
    java_versions: [],
    allow_properite: [],
    using_ports: [],
    versions: []
};